import React, { forwardRef } from 'react';
import { Order } from '../../types/order';
import './invoice.css';

interface InvoiceProps {
    order: Order;
}

const Invoice = forwardRef<HTMLDivElement, InvoiceProps>(({ order }, ref) => (
    <div ref={ref} className="invoice-container">
        <div className="invoice-header">
            <h2>Order Invoice</h2>
            <div>
                <b>Customer Code:</b> {order.customerCode}<br />
                <b>Card Link:</b> {order.cardLink}<br />
                <b>Status:</b> {order.status}<br />
                <b>Total:</b> ${order.totalPrice}<br />
                <b>Pay:</b> ${order.pay}<br />
                <b>Remain:</b> ${order.remain}
            </div>
        </div>

        <h3 style={{ marginTop: 24 }}>Items</h3>
        <table className="invoice-table">
            <thead>
                <tr>
                    <th>Qty</th>
                    <th>Image</th>
                    <th>Note</th>
                    <th>Customization</th>
                </tr>
            </thead>
            <tbody>
                {order.items?.map((item, idx) => (
                    <tr key={idx}>
                        <td>{item.qty}</td>
                        <td>
                            {item.image && (
                                <img src={item.image} alt="Item" style={{ width: 50, height: 50, borderRadius: 6, border: '1px solid #eee' }} />
                            )}
                        </td>
                        <td>{item.note || '-'}</td>
                        <td>
                            {(item.customization?.note || '') + ' ' + (item.customization?.detail || '')}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
));
export default Invoice;
